const list = state => state.list;
const counters = state => state.counters;

export default {
  list,
  counters,
};
